<template>

</template>

<script>
  export default {
    name: "loginInfo",

    created() {
      this.$alert('登录信息失效', '提示', {
        confirmButtonText: '确定',
        callback: action => {
          localStorage.removeItem('access-admin')
          this.$router.push('/login')
        }
      });
    }

  }

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/infoPage/Error.vue